import React from 'react';
import { SignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

// This component renders the sign-in page using Clerk's SignIn component.
function SignInPage() {
  const navigate = useNavigate();

  return (
    <>
      <SignedIn>
        {() => {
          navigate('/');
          return null;
        }}
      </SignedIn>
      <SignedOut>
        <div className="sign-in-up">
          <SignIn />
        </div>
        
      </SignedOut>
    </>
  );
}

export default SignInPage;